import {Model} from '@vuex-orm/core'

export default class LtmHasRoomtypeHasRoomltmAt extends Model {
  static entity = 'ltmHasRoomtypeHasRoomltmsAt'

  static fields() {
    return {
      id: this.number(null),
      ltms_id: this.number(null),
      roomltms_id: this.number(null),
      roomtypes_id: this.number(null),
      default: this.boolean(false),
    }
  }
}
